import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDNm-Qgwmy5QN1zepSfcFT8QNaF4dMn6oU",
  authDomain: "edora-dc48e.firebaseapp.com",
  projectId: "edora-dc48e",
  storageBucket: "edora-dc48e.firebasestorage.app",
  messagingSenderId: "926451489478",
  appId: "1:926451489478:web:0c5dd729885f82d5ee95c7"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

if (typeof window !== "undefined") {
  window.__FIREBASE_AUTH__ = auth;
}
